import { useQuery } from '@tanstack/react-query';
import { getStbClient } from 'Features/network';
import { ProfileV3Dto } from './profile.types';

export const useProfileV3 = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['profileV3'],
    queryFn: () => getProfileV3(),
    refetchOnWindowFocus: false,
    retry: 3,
  });

  return {
    data,
    loading: isLoading,
    error,
  };
};

async function getProfileV3() {
  const client = await getStbClient();
  const res = await client.get<ProfileV3Dto>(`/customer/core-data.v3`);

  return res.data;
}
